var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgALearnBentcorner36 = function SvgALearnBentcorner36(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21120_236515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 36H0V3C0 1.34314 1.34315 0 3 0H36V36Z",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36L36 0Z",
    fill: "#2C5A82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21120_236515"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 36H0V3C0 1.34314 1.34315 0 3 0H36V36Z",
    fill: "white"
  })))));
};
export { SvgALearnBentcorner36 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxMTIwXzIzNjUxNSkiPgo8cGF0aCBkPSJNMzYgMzZIMFYzQzAgMS4zNDMxNCAxLjM0MzE1IDAgMyAwSDM2VjM2WiIgZmlsbD0iI0RDRUNGQSIvPgo8cGF0aCBkPSJNMzYgMEgwVjM2TDM2IDBaIiBmaWxsPSIjMkM1QTgyIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjExMjBfMjM2NTE1Ij4KPHBhdGggZD0iTTM2IDM2SDBWM0MwIDEuMzQzMTQgMS4zNDMxNSAwIDMgMEgzNlYzNloiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";